import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ModalInjectorService} from '../../services/modal-injector.service';
import {PageService} from '../../services/page.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-solicitudes-firma-modal',
  templateUrl: './solicitudes-firma-modal.component.html',
  styleUrls: ['./solicitudes-firma-modal.component.css']
})
export class SolicitudesFirmaModalComponent implements OnInit {

  show = false;
  aviso = 'La solicitud carece de los datos minimos necesarios para enviar la firma (revisar nombre, apellidos, NIF, teléfono, email, provincia, población, cp, dirección, matrícula/bastidor) y si fuera necesario, los datos del apoderado.';

  docu = {
    rol: '',
    docu: {
      poder: false,
      mandato: false,
      compraVenta: false
    },
  };
  spinnerFirma = false;
  constructor( public dialogRef: MatDialogRef<SolicitudesFirmaModalComponent>,
               @Inject(MAT_DIALOG_DATA)public data: any, private checkData: ModalInjectorService, private pageService: PageService) { }

  ngOnInit(): void {
    this.show =  this.checkData.checkDataMatriculacion(this.data);
    //console.log(this.checkData.checkDataMatriculacion(this.data))
    this.setRole();
  }
  setRole(): void{
    if ( this.data.tipo && this.data.tipo.includes('MATRICULACION')){
      this.docu.rol = 'VENDEDOR';
    }
    else if (this.data.colaborador === this.data.apellido1){
      this.docu.rol = 'COMPRADOR';
    }else if(this.data.colaborador === this.data.apellido1Vendedor){
      this.docu.rol = 'VENDEDOR';
    }else {
      this.docu.rol = 'INTERMEDIARIO';
    }

    console.log(this.data);
    console.log(this.docu);
  }

  submit(): void {
    const data = {
      solicitud: this.data,
      docu: this.docu
    };
    this.spinnerFirma =  true;
    this.pageService.postViafirmaFromSolicitudes(data).subscribe({
      next: value => {
        Swal.fire('', 'Firmas enviadas', 'success');
        this.spinnerFirma =  false;
        this.dialogRef.close();
      },
      error: err => {
        Swal.fire('', err.message, 'warning');
        this.spinnerFirma =  false;
        this.dialogRef.close();
      }
    });
  }
}
